<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex flex-column align-items-center">
            <div class="modal-title text-center" id="modal-title-default">
                {{ 'LOGOUT_MODAL.TITLE' | translate }}
            </div>
            <i class="material-icons alarm">alarm</i>
            <div class="text-center">
                {{ 'LOGOUT_MODAL.MSG_1' | translate }} {{ countdown }} {{ 'LOGOUT_MODAL.MSG_2' | translate }}
            </div>
        </div>
        <div class="d-flex flex-column align-items-center">
            <button class="modal-btn" (click)="stay()">  {{ 'LOGOUT_MODAL.BTN_STAY' | translate }}</button>
            <button class="modal-btn" (click)="logout()">{{ 'LOGOUT_MODAL.BTN_LOGOUT' | translate }}</button>
        </div>
    </div>
</ng-template>